import { Box, Flex, Text } from "@mantine/core";
import { IIssueApi, IIssueTodoItem } from "@schemas/issueSchema";
import { IconLock } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import SimpleStampCheck from "../../../../../../components/SimpleStampCheck/SimpleStampCheck";
import { getProjectIdFromUrl } from "../../../../../utils";
import { useDoUpdateIssueMutation } from "../../../issueRTKLegacy";
import { selectIssueBoard } from "../../../issueSelectors";
import { issueBoardHasClientAccess } from "../../../issueUtils";
import "../KanbanCard/KanbanCard.css";

export const KanbanCardSJA: React.FC<{
  content: IIssueApi;
  onOpen: () => void;
  isMobile?: boolean;
}> = ({ content, onOpen, isMobile = false }) => {
  const issueBoard = useSelector(selectIssueBoard);
  const showClientLock = issueBoardHasClientAccess(issueBoard) && content.clientAccess !== true;
  const history = useHistory();
  const projectId = getProjectIdFromUrl(history.location.pathname);

  const [updateIssue, { isLoading: isUpdating }] = useDoUpdateIssueMutation();

  let todos = content.todos as IIssueTodoItem[];

  if (issueBoard?.showCompletedTodosInKanban === false) {
    todos = todos?.filter((todo) => todo.completedDate == null) ?? [];
  }

  return (
    <Box
      w={isMobile ? "100%" : 250}
      mb={8}
      onClick={onOpen}
      style={{ borderRadius: 6, overflow: "hidden", cursor: "pointer" }}
      className="shadowThin"
    >
      {/* Header */}
      <Flex bg="dark" px="xs" gap="xxs" align="center" style={{ height: 45, borderRadius: "6px 6px 0 0" }}>
        {/* {content.taskOrIssue === "ISSUE" && (
          <IssueIcon style={{ fontSize: "0.8em", color: "white", marginRight: "2px" }} />
        )} */}
        {/* {content.taskOrIssue === "TASK" && <ActionIcon style={{ fontSize: "1em", color: "white" }} />} */}
        <Text c="warmgray.1" fw={700} size="sm">
          {content.otherAttributesData?.B}
        </Text>
        {showClientLock && <IconLock color="var(--mantine-color-red-5)" size={16} style={{ flexShrink: 0 }} />}
        <Box style={{ flex: 1 }} />
      </Flex>

      {/* Body */}
      <Flex
        direction="column"
        bg="white"
        p="xxs"
        gap="xs"
        style={{
          fontSize: 12,
          maxHeight: content.showTodosInKanban === true ? "none" : 250,
          overflow: "hidden",
        }}
      >
        <Text size="sm" lh="xs">
          <Text span fw={700}>
            Tiltak:
          </Text>{" "}
          {content.otherAttributesData?.A}
        </Text>

        <Text size="sm" lh="xs">
          <Text span fw={700}>
            Restrisiko:
          </Text>{" "}
          {content.otherAttributesData?.C}
        </Text>

        <Text size="sm" lh="xs">
          <Text span fw={700}>
            Kommentar:
          </Text>{" "}
          {content.otherAttributesData?.D}
        </Text>
        <Box
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SimpleStampCheck
            toggled={Boolean(content.otherAttributesData?.E)}
            toggle={(newValue) => {
              updateIssue({
                projectId: projectId,
                issueBoardId: issueBoard?._id,
                issueId: content._id,
                attr: "otherAttributesData.E",
                value: newValue,
                oldValue: content.otherAttributesData?.E,
              });
            }}
          />
        </Box>
      </Flex>
    </Box>
  );
};
